import { Button, Stack } from '@mui/material';
import FrameCard from 'Global/Components/CommonComponents/FrameCard/FrameCard';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import React, { useState } from 'react';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import useHandlePageData from 'Routes/Public/GetReportWithSMS/Hooks/useHandlePageData';
import { useNavigate } from 'react-router-dom';
import { hwndjs } from 'utils/hwnd';

const PacsCard = ({ pacs }) => {
  // console.log('pacs=>', pacs);

  const conferDateTime_label = FindLangKey(
    'lab-test-title-date-time'
  );
  const conferDepartment_label = FindLangKey(
    'lab-test-title-referral-location'
  );
  const title_label = FindLangKey('lab-test-title-title');
  const showEditor_label = FindLangKey(
    'genral-public-show-editor'
  );

  const navigate = useNavigate();


  console.log('pacspacs--->',pacs)

  return (
    <React.Fragment>
      <FrameCard
        jsx={
          <Stack
            sx={{
              backgroundColor: 'white',
              borderRadius: '20px',
              padding: '.5em',
              gap: '1em',
            }}
          >
            <Stack
              direction="row-reverse"
              justifyContent="space-between"
            >
              <p>{conferDateTime_label}</p>
              <Stack direction="row">
                <p>{pacs?.DateConfer}</p> - 
                <p>{pacs?.TimeConfer}</p>
              </Stack>
            </Stack>
            <Stack
              direction="row-reverse"
              justifyContent="space-between"
            >
              <p>{conferDepartment_label}</p>
              <Stack direction="row">
                <p>
                  {ArabicToPersian(pacs?.NameDepartment)}
                </p>
              </Stack>
            </Stack>
            <Stack
              direction="row-reverse"
              justifyContent="space-between"
              sx={{
                wordWrap: 'break-word',
                gap: '1em',
              }}
            >
              <p>{title_label}</p>
              <Stack direction="row">
                <p>{ArabicToPersian(pacs?.NameService)}</p>
              </Stack>
            </Stack>

            <Button
              sx={{
                color: `${themeColors.ColorPrimary} !important`,
                maxHeight: '40px',
              }}
              variant="contained"
              onClick={() => {
                navigate({
                  pathname: `/Home/GetReport`,
                  search: `keyConfer=${hwndjs(
                    pacs.PacsKey
                  )}&i=${pacs.PacsInstanceId}`,
                });
              }}
            >
              {showEditor_label}
            </Button>
          </Stack>
        }
        cardProps={{
          borderRadius: '20px',
          padding: '.3em',
        }}
      />
      <br />
    </React.Fragment>
  );
};

export default PacsCard;
